module.exports = __webpack_public_path__ + "img/marketing-hover.276b21f7.png";